import { SearchableCardOption } from "@risalabs_frontend_org/oasis-ui-kit";
import { SiteDetailsFormValues } from "./siteDetailsForm.types";

/** Configuration for one row in the site details form. */
export interface SiteDetailsFieldConfig {
  /** Form value key. */
  key: keyof SiteDetailsFormValues;
  /** Left-column label. */
  label: string;
  /** SearchableCard trigger placeholder. */
  placeholder: string;
  /** SearchableCard search input placeholder. */
  searchPlaceholder: string;
  /** Marks the field as required in the UI. */
  required?: boolean;
}

/** Fixed Type dropdown choices. The label is shown; the value is stored. */
export const SITE_TYPE_OPTIONS: SearchableCardOption[] = [
  { label: "Internal", value: "internal" },
  { label: "External", value: "external" },
];

/** Ordered field definitions for the site details form. */
export const SITE_DETAILS_FIELDS: SiteDetailsFieldConfig[] = [
  {
    key: "type",
    label: "Type",
    placeholder: "Type",
    searchPlaceholder: "Select Type",
    required: true,
  },
  {
    key: "alias",
    label: "Alias",
    placeholder: "Alias",
    searchPlaceholder: "Search alias",
  },
  {
    key: "npi",
    label: "NPI",
    placeholder: "NPI",
    searchPlaceholder: "Search NPI",
    required: true,
  },
  {
    key: "site_name",
    label: "Name",
    placeholder: "Name",
    searchPlaceholder: "Search name",
    required: true,
  },
  {
    key: "address",
    label: "Address",
    placeholder: "Address",
    searchPlaceholder: "Search address",
  },
  {
    key: "city",
    label: "City",
    placeholder: "City",
    searchPlaceholder: "Search city",
  },
  {
    key: "state",
    label: "State",
    placeholder: "State",
    searchPlaceholder: "Search state",
  },
  {
    key: "zip",
    label: "Zip",
    placeholder: "Zip",
    searchPlaceholder: "Search zip",
  },

];

/** Per-field dropdown options keyed by form field. */
export type SiteDetailsFieldOptions = Partial<
  Record<keyof SiteDetailsFormValues, SearchableCardOption[]>
>;
